<template>
  <div>
    <div class="d-flex justify-space-between mb-4">
      <div>
        <div class="page-title mb-2">แก้ไขกิจกรรม</div>
      </div>
    </div>
    <divcard class="mt-5">
      <v-form ref="form" v-model="valid" lazy-validation>
        <div class="font-20 font-w-700">
          ข้อมูลกิจกรรม
        </div>
        <div class="d-flex flex-column py-5">
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                ชื่อกิจกรรม
                <span class="theme-color-seven txt-normal">
                  *
                </span>
              </div>
              <TextField theme="3" v-model="form.name" placeholder="โปรดระบุ"
                :rules="[(v) => !!v || 'กรุณาระบุชื่อกิจกรรม']" @onChange="setFormField('name', $event)" required />
            </div>
          </div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                วันที่เริ่ม
                <span class="theme-color-seven txt-normal">
                  *
                </span>
              </div>
              <DatePicker :value="startDate" @onInput="startDate = $event"></DatePicker>
            </div>
            <div class="flex">
              <div class="mb-1 black--text">
                จนถึง
                <span class="theme-color-seven txt-normal">
                  *
                </span>
              </div>
              <DatePicker :value="endDate" @onInput="endDate = $event"></DatePicker>
            </div>
          </div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                เวลาที่เริ่ม
                <span class="theme-color-seven txt-normal">
                  *
                </span>
              </div>
              <TimePicker 
                :value="startTime" 
                @onInput="startTime = $event" 
                ></TimePicker>
            </div>
            <div class="flex">
              <div class="mb-1 black--text">
                จนถึง
                <span class="theme-color-seven txt-normal">
                  *
                </span>
              </div>
              <TimePicker 
                :value="endTime" 
                @onInput="endTime = $event"
                ></TimePicker>
            </div>
          </div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                สถานที่
                <span class="theme-color-seven txt-normal">
                  *
                </span>
              </div>
              <TextField theme="3" v-model="form.location" placeholder="โปรดระบุ"
                :rules="[(v) => !!v || 'กรุณาระบุสถานที่']" @onChange="setFormField('location', $event)" required />
            </div>
          </div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                แนบลิงค์
              </div>
              <TextField theme="3" v-model="form.location_link" placeholder="โปรดระบุ"
                @onChange="setFormField('location_link', $event)" />
            </div>
          </div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                รายละเอียด
                <span class="theme-color-seven txt-normal">
                  *
                </span>
              </div>
              <TextArea theme="3" v-model="form.description" placeholder="โปรดระบุ"
                :rules="[(v) => !!v || 'กรุณาระบุรายละเอียด']" @onChange="setFormField('description', $event)" required />
            </div>
          </div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                ผู้เข้าร่วม
              </div>
              <TextArea theme="3" v-model="form.participants" 
              :placeholder="'1.\n2.\n3.'" @onChange="setFormField('participants', $event)" />
            </div>
          </div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                เบอร์โทร ผู้ประสานงาน
                <span class="theme-color-seven txt-normal">
                  *
                </span>
              </div>
              <TextField theme="3" v-model="form.coordinator_phone" placeholder="โปรดระบุ"
                :rules="[
                  (v) => !!v || 'กรุณาระบุเบอร์โทร ผู้ประสานงาน',
                ]"
                @onChange="setFormField('coordinator_phone', $event)"
                required />
            </div>
          </div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                ประธานกิจกรรม
                <span class="theme-color-seven txt-normal">
                  *
                </span>
              </div>
              <TextField theme="3" v-model="form.event_leader" placeholder="โปรดระบุ"
                :rules="[(v) => !!v || 'กรุณาระบุประธานกิจกรรม']" @onChange="setFormField('event_leader', $event)"
                required />
            </div>
          </div>
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                ผู้จัดกิจกรรม
                <span class="theme-color-seven txt-normal">
                  *
                </span>
              </div>
              <TextField theme="3" v-model="form.organizer" placeholder="โปรดระบุ"
                :rules="[(v) => !!v || 'กรุณาระบุผู้จัดกิจกรรม']" @onChange="setFormField('organizer', $event)" required />
            </div>
          </div>
        </div>
      </v-form>
    </divcard>
    <div class="d-flex justify-space-between mt-10">
      <div>
        <Button theme="2" @onClick="routeBack">ยกเลิก</Button>
      </div>
      <div>
        <Button theme="1" @onClick="submitForm">บันทึก</Button>
      </div>
    </div>
  </div>
</template>

<script>
import TextField from "@/components/input/TextField.vue";
import TextArea from "@/components/input/TextArea.vue";
import Button from "@/components/input/Button";
import DatePicker from "@/components/input/DatePicker.vue";
import TimePicker from "@/components/input/TimePicker.vue";

export default {
  name: 'CalendarActivityId',
  components: {
    TextField,
    Button,
    TextArea,
    DatePicker,
    TimePicker
  },
  data() {
    return {
      form: {

      },
      startDate: undefined,
      endDate: undefined,
      startTime: undefined,
      endTime: undefined,
      valid: true,
    }
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      let res = await this.$apiFire("CalendarActivity/edit", { id: this.$route.params.id });
      if (res) {
        // เช็คสิทธิ์ในการแก้ไข
        if (!this.canEditEvent(res.data)) {
          this.$store.commit("General/setModal", {
            theme: "warning",
            title: "ไม่มีสิทธิ์",
            text: "คุณไม่มีสิทธิ์ในการแก้ไขกิจกรรมนี้",
            buttonText: "ตกลง",
            showCancel: false,
            action: () => {
              this.$router.push({ name: 'CalendarActivity' });
            },
          });
          return;
        }

        this.form = res.data;
        this.startDate = res.data?.start_date;
        this.endDate = res.data?.end_date;
        this.startTime = res.data?.start_time;
        this.endTime = res.data?.end_time;
      }
    },
    async submitForm() {
      if (this.$refs.form.validate()) {
        const data = {
          ...this.form,
          start_date: this.startDate,
          end_date: this.endDate,
          start_time: this.startTime,
          end_time: this.endTime,
        };
        let res = await this.$apiFire("CalendarActivity/update", data);
        if (res) {
          this.routeBack();
        }
      }
    },
    setFormField(field, value) {
      this.form[field] = value;
      this.$forceUpdate();
    },
    routeBack() {
      this.$router.push({ name: 'CalendarActivity' })
    },
    canEditEvent(event) {
      const currentUser = this.$store.state.Auth.User;

      // ถ้าเป็น สป และ region เป็น null ก็สามารถแก้ไขได้เฉพาะ user_type ที่ตรงกัน
      if ((event.user_type === "สป.อว." || event.user_type?.includes("สป")) && !event.region) {
        return currentUser.user_type === event.user_type || currentUser.user_type?.includes("สป");
      }

      // ถ้าเป็น RSP ต้อง user_type และ region ตรงกัน
      if (event.user_type === "RSP" && event.region) {
        return currentUser.user_type === "RSP" && currentUser.region === event.region;
      }

      // สำหรับกรณีอื่นๆ ให้เช็ค user_type ที่ตรงกัน
      return currentUser.user_type === event.user_type;
    }
  }
}
</script>

<style lang="scss" scoped>

</style>